import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={597.392}
    height="34.62mm"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 448.04 98.14"
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={414.7}
        y1={49.65}
        x2={425.97}
        y2={49.65}
        gradientTransform="translate(-88.75) skewX(-14)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#36a9e1" />
        <stop offset={1} stopColor="#45a3a4" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={458.73}
        y1={45.42}
        x2={469.59}
        y2={45.42}
        xlinkHref="#a"
      />
      <linearGradient
        id="c"
        x1={267.45}
        y1={45.42}
        x2={278.32}
        y2={45.42}
        xlinkHref="#a"
      />
      <linearGradient
        id="d"
        x1={292.79}
        y1={54.07}
        x2={301.11}
        y2={54.07}
        xlinkHref="#a"
      />
      <linearGradient
        id="e"
        x1={94.01}
        y1={49.07}
        x2={541.07}
        y2={49.07}
        xlinkHref="#a"
      />
    </defs>
    <path
      d="M320.75 43.54c-3.2 0-6.23 2.3-7.18 6.11s.94 6.11 4.13 6.11 6.19-2.3 7.14-6.11-.9-6.11-4.09-6.11Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M364.68 43.13c-2.91 0-5.44 1.76-6.6 4.59h10.86c.24-2.79-1.4-4.59-4.27-4.59Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M173.4 43.13c-2.91 0-5.44 1.76-6.6 4.59h10.86c.24-2.79-1.4-4.59-4.27-4.59Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M190.57 54.03c-.4 1.6.69 2.66 2.94 2.66 2.13 0 4.22-.98 5.46-2.99l.56-2.25h-4.39c-2.99 0-4.21 1.11-4.58 2.58Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M433.2.48c-25.59.06-51.15 0-76.72 0-31.27 0-62.61-1.01-94.14.47-19.37.91-38.51-.87-57.69-.94-19.82-.07-39.72.16-59.67.63-39.92.94-80.05 2.83-120.25 5.15-12.12.7-31.64 9.84-22.26 23.47 5.37 6.73 16.82 3.2 25.3 3.84 17.45.64 38.75-3.84 53.14 2.38-.03.69-.25 1.68-.65 2.71-8.09 11.21-10.33 11.61-7.21 22.99 3.02 5.54 5.19 10.98.74 17.92-3.89 6.07 2.23 15.15 6.5 17.21 3.73 1.79 8.42 1.82 12.97 1.82H408.85c10.45 0 21.13-8.55 23.74-19l14.87-59.66c2.61-10.45-3.81-19-14.26-19ZM155.75 60.67h-21.03l7.15-28.7h6.64l-5.81 23.29h14.39l-1.35 5.41Zm26.9-9.22h-16.68c-.07 2.75 1.85 4.43 5.21 4.43 2.34 0 4.19-.7 6.07-2.13l2.48 3.69c-2.63 2.34-6.01 3.57-9.99 3.57-7.63 0-11.39-4.8-9.75-11.36s7.87-11.36 14.6-11.36 10.4 4.35 8.63 11.44c-.12.49-.38 1.19-.55 1.72Zm20.98 9.22h-5.99l.68-2.75c-1.69 2.01-4.25 3.07-7.49 3.07-5.17 0-7.52-2.87-6.57-6.68s4.39-6.6 11.12-6.6h5.08c.68-2.75-.56-4.35-4-4.35-2.34 0-4.95.78-6.87 2.05l-1.18-4.47c2.85-1.72 6.65-2.66 10.18-2.66 6.72 0 9.84 3.12 8.17 9.8l-3.14 12.59Zm23.58-16.48c-.52-.04-.92-.08-1.41-.08-3.53 0-6.34 1.93-7.4 6.15l-2.6 10.41h-6.4l5.5-22.06h6.11l-.73 2.91c2.09-2.13 4.99-3.24 8.39-3.24l-1.47 5.9Zm22.25 16.48h-6.4l2.9-11.64c.89-3.57-.34-5.21-3.17-5.21-3.07 0-5.76 1.89-6.77 5.94l-2.72 10.9h-6.4l5.5-22.06h6.11l-.64 2.58c2.19-1.89 5.03-2.91 8.02-2.91 5.21 0 8.39 3.03 6.71 9.76l-3.15 12.63Zm43.94 0 4.25-17.22-11.98 14.18h-2.99l-4.96-13.82-4.2 16.85h-6.23l7.15-28.7h5.49l6.29 17.83 15.02-17.83h5.45l-7.07 28.7h-6.23Zm23 .33c-7.01 0-10.96-4.71-9.3-11.36 1.66-6.64 7.96-11.36 14.97-11.36s10.92 4.71 9.26 11.36S323.42 61 316.41 61Zm34.24-16.81c-.52-.04-.92-.08-1.41-.08-3.53 0-6.34 1.93-7.4 6.15l-2.6 10.41h-6.4l5.5-22.06h6.11l-.73 2.91c2.09-2.13 4.99-3.24 8.39-3.24l-1.47 5.9Zm23.28 7.26h-16.69c-.07 2.75 1.85 4.43 5.21 4.43 2.34 0 4.19-.7 6.07-2.13l2.48 3.69c-2.63 2.34-6.01 3.57-9.99 3.57-7.62 0-11.39-4.8-9.75-11.36s7.87-11.36 14.6-11.36 10.4 4.35 8.63 11.44c-.12.49-.38 1.19-.55 1.72Zm9.26 9.55c-2.3 0-3.52-1.68-3.01-3.73s2.55-3.65 4.85-3.65 3.55 1.56 3.03 3.65-2.57 3.73-4.87 3.73Zm5.64-10.29h-6.19c1.43-5.74 8.14-7.01 9.03-10.58.5-2.01-.94-3.28-3.61-3.28s-4.92 1.15-6.7 3.03l-4.23-2.91c3.05-3.36 7.44-5.49 12.97-5.49 6.15 0 9.73 2.75 8.52 7.58-1.64 6.56-8.71 7.3-9.79 11.64Z"
      style={{
        fill: "url(#e)",
      }}
    />
  </svg>
)

export default SvgComponent
